import { Observable } from 'rxjs';

/**
 * Svelte 5 rune helper for subscribing to an RxJS Observable.
 * Returns an object with a reactive `current` property.
 * Properly unsubscribes when the component unmounts.
 */
export function useObservable<T>(
  observable$: Observable<T>,
  initialValue: T
): { readonly current: T } {
  let value = $state(initialValue);

  $effect(() => {
    const subscription = observable$.subscribe((v) => {
      value = v;
    });
    return () => subscription.unsubscribe();
  });

  return {
    get current() {
      return value;
    },
  };
}
